import { render, staticRenderFns } from "./veicleRetrunDetail.vue?vue&type=template&id=3d4da19c&"
import script from "./veicleRetrunDetail.vue?vue&type=script&lang=js&"
export * from "./veicleRetrunDetail.vue?vue&type=script&lang=js&"
import style0 from "./veicleRetrunDetail.vue?vue&type=style&index=0&id=3d4da19c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports